<!-- <div class="popup" [class.popup-filter-shadow]="!isFavouriteScreen"> -->

    <div class="frame-2130"  [class.popup-filter-shadow]="!isFavouriteScreen">        
        <app-site-info-widget style="margin-left : auto;"
            [sitePopupInfo]="sitePopupInfo"
            [sitePhoto]="sitePhoto"
            [isFavouriteScreen]="isFavouriteScreen"
            [mobileView]="mobileView"
            [showScreenshot]="showScreenshot"
            [closable]="closable"
            (closed)="onCloseButtonClicked"
            >
        </app-site-info-widget>
        
    </div>   

<!-- </div> -->
